import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-progress-bar-tamanos',
  templateUrl: './progress-bar-tamanos.component.html',
  styleUrls: ['./progress-bar-tamanos.component.scss']
})
export class ProgressBarTamanosComponent implements OnInit{

   @Input() data: any;  
   @Input() box_size: any;  

   @Output() actionTamanos = new EventEmitter<void>();
   @Input() isSelected: boolean = false;

    
      chartData:any;
    
      colorsSize:any = {
        'chica': { color:'#0091ea'},
        'mediana': { color:'#d22042'},
        'grande': { color:'#4be2a5'},
      };
    
      constructor(
      ) { }
    
      ngOnInit(): void {
        this.chartData = this.barChartProgress(this.data);
      }
    
      barChartProgress = (data:any) => {
        return (
          {
            chart: {
              height: 55,
              type: "bar",
              stacked: true,
              sparkline: {
                enabled: true,
              },
              events: {
                dataPointSelection: (event: any, chartContext: any, config: any) => {
                  this.actionTamanos.emit();
                }
              },
            },
            plotOptions: {
              bar: {
                horizontal: true,
                barHeight: "30%",
                colors: {
                    backgroundBarColors: ["#bbb"],
                    backgroundBarOpacity: 0.2,
                },
              },
            },
            colors: [this.getColorForSize(this.box_size)],
            stroke: {
              width: 0,
            },
            fill: {
              colors: [this.getColorForSize(this.box_size)],
            },
            series: [
              {
                data: [data],
              },
            ],
            tooltip: {
              enabled: false,
            },
            xaxis: {
              categories: ["Packed"],
            },
            yaxis: {
              max: 100,
              min: 0,
            },
            responsive: [
              {
                breakpoint: 767,
                options: {
                  title: {
                    style: {
                      fontSize: "16px",
                    },
                  },
                },
              },
            ]
          }
        )
      }

      getColorForSize(size: string): string {
        if(size != null){
          size = size.toLowerCase();
          for (let key in this.colorsSize) {
            if (size.includes(key)) {
              return this.colorsSize[key].color;
            }
          }
        }
        return '#000000';
      }
    
}
